import Anchor from './Anchor';
import AnchorLink from './AnchorLink';
Anchor.Link = AnchorLink;
export default Anchor;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/anchor/index.js
// module id = 819
// module chunks = 14